import cloneDeep from 'lodash-es/cloneDeep'

/**
 *  各平台歌词基础抽象类类
 *
 * @property {String} _template 歌词模板
 * @property {Object} _params 歌词相关信息对象，用于替换模板插槽的数据
 *
 * 子类必须实现的方法有：
 * @method _setParams 设置歌词信息对象
 * @method _generateContent
 */
export default class Lyric {
  _template = ''
  _params = {
    __trackName__: '',
    __singerName__: '',
    __albumName__: '',
    __author__: '',
    __content__: '',
  }

  _type = ''
  ext = 'txt'
  nameExt = ''
  lyricAST = null // LyricAST 实例对象
  lyricText = ''
  constructor(type, lyricText = '') {
    if (new.target === Lyric) {
      throw new TypeError('Lyric is abstract class!')
    }
    if (!type && typeof type !== 'string') {
      throw new TypeError('缺少初始化参数 type')
    }

    this.lyricText = lyricText
    this._type = type
    this.params = {}
  }

  get type() {
    return this._type
  }

  _setParams(songInfo) {
    this.params = {
      ...this.params,
      __trackName__: songInfo.trackName,
      __singerName__: songInfo.singerName,
      __albumName__: songInfo.albumName,
      __author__: songInfo.author,
    }
  }

  _generateContent(lyricAST) {
    const { ASTList, sentencesTimeList } = lyricAST
    let content = ''

    for (let i = 0; i < ASTList.length; i++) {
      const line = ASTList[i]
      const lineTime = sentencesTimeList[i]
      let lineText = this._getLineMark(lineTime)

      for (let j = 0; j < line.length; j++) {
        const wordObj = line[j]
        lineText += this._getWordMark(lineTime, wordObj)
      }

      content += `${lineText}\n`
    }

    this.params.__content__ = content
    return content
  }

  /**
   * 生成行时间标记
   * @param {Array} lineTime
   * @param {Number} lineTime[0] - 行开始时间
   * @param {Number} lineTime[1] - 行持续时间
   */
  _getLineMark(lineTime) {
    const round = Math.round

    return `[${round(lineTime[0])},${round(lineTime[1])}]`
  }

  /**
   * 生成词标记
   * @param {Array} lineTime
   * @param {Number} lineTime[0] - 行开始时间
   * @param {Number} lineTime[1] - 行持续时间
   * @param {Object} wordObj
   * @param {String} wordObj.word 当前歌词字符串
   * @param {Number} wordObj.start 词开始时间
   * @param {Number} wordObj.duration 词持续时间
   */
  _getWordMark(lineTime, wordObj) {
    const round = Math.round

    return `${wordObj.word}(${round(wordObj.start)},${round(wordObj.duration)})`
  }

  textToAST() {
    if (new.target === Lyric) {
      throw new TypeError('must override by subclass!')
    }
  }

  /**
   * 从 LyricAST 读取数据
   * @param {LyricAST} lyricAST
   */
  readFromAST(lyricAST) {
    this.lyricAST = cloneDeep(lyricAST)
    this._setParams(this.lyricAST.songInfo)
    this._generateContent(this.lyricAST)
  }

  /**
   * 生成最终的歌词文本，保存在 lyricText 并且返回
   * @return {String} lyricText
   */
  generateLyric() {
    const { params, _template } = this
    let result = _template

    for (const key in params) {
      const re = new RegExp(key, 'g')
      result = result.replace(re, params[key])
    }
    result = result.replace(/__timestamp__/g, Date.now())
    this.lyricText = result

    return result
  }
}
